import Layout from "../components/layout"

const TermsAndConditions = () => {
  return (
    <Layout>
      <button
        type="button"
        onClick={() => {
          throw new Error("Sentry Frontend Error")
        }}
      >
        Throw error
      </button>
      <div className="section section--big section--bg-world">
        <div className="wrapper">
          <div className="headline">Şartlar ve Koşullar</div>
        </div>
      </div>
      <div className="section">
        <div className="wrapper">
          <div className="generic-content-container">
            <main className="content content--with-smaller-container">
              <h5 className="MuiTypography-root MuiTypography-h5 MuiTypography-gutterBottom">Şartlar ve koşullar</h5>
              <p>
                Bu bölüm işkıbrıs.com&lsquo;un genel kullanım şartlarını, genel ve yasal sorumlulukları içermektedir. Sistemi kullanmadan önce aşağıda yazanları okumanız ve sistemi
                kullanmanız durumunda bu sayfalarda yazılı şartları peşinen kabul ettiğiniz anlamına gelir. Eğer bu sayfada yazılı şartları kabul etmez iseniz lütfen sistemi
                kullanmayınız. Bu sayfada bulunan genel kullanım şartlarını işkıbrıs.com dilediği zaman değiştirme hakkına sahiptir. Siteyi ziyaret ettiğinizde bu sayfayı okumanız
                tavsiye edilir.
              </p>
              <h6>Kullanım Kuralları</h6>
              <ul>
                <li>Yanlış, düzensiz, eksik ve yanıltıcı bilgilerin, genel ahlak kurallarına uygun olmayan ifadeleri içeren bilgilerin siteye kaydedilmesi durumunda,</li>
                <li>Sitede yer alan bilgilerin kısmen veya tümüyle kopyalanarak farklı amaçlarla kullanılması veya kullanılmaya çalışılması durumunda,</li>
                <li>Üyelere verilen kullanıcı adı, şifre gibi bilgilerin, üçüncü kişi ve kuruluşlarla paylaşılması durumunda,</li>
                <li>Sitenin genel güvenliğini tehdit edecek, kullanılan yazılımların çalışmasını engelleyecek yazılımların yapılması, yapılmaya çalışılması durumunda,</li>
                <li>Virüs vasıtasıyla sitenin çalışmasını engellemek,</li>
                <li>Siteyi kullanan diğer kullanıcı bilgilerine girmek veya girmeye çalışmak.</li>
              </ul>
              <h6>İçerik Kopyalanması</h6>
              <p>
                Bu Sitede yer alan bütün yazılar, grafikler, istatistiki bilgiler ve resimler 5846 sayılı Fikir ve Sanat Eserleri Kanunu ile ilgili sair yasa ve yönetmeliklerden
                doğan tüm fikri ve sınai mülkiyet hakları, münhasıran işkıbrıs.com’a aittir. Sitede yer alan yazılar, grafikler, istatistiki bilgiler ve resimler işkıbrıs.com’un
                yazılı onayı olmaksızın kopyalanması, çoğaltılması, yayınlanması veya yeniden yayınlanması yasaktır. Aynı şekilde Sitenin isim hakkı ve logosu münhasıran
                işkıbrıs.com’a ait olup hiçbir surette işkıbrıs.com’un yazılı onayı olmaksızın kullanılamaz, 3. kişi ve kuruluşların kullanımına sunulamaz. Site münhasıran
                işkıbrıs.com’un kullanımında olup Sitede yer alan herhangi bir unsur diğer bir mecrada veya Internet sitesinde yayınlanamaz veya işkıbrıs.com’un izni olmadan başka
                bir internet sitesinden işkıbrıs.com&lsquo;a link verilemez, yönlendirme yapılamaz. Ayrıca sitenin tasarımı ve veritabanı oluşturulmasında ,aynı zamanda tüm
                kullanıcılara sağlanan fonksiyonların hazırlanmasında kullanılan yazılımın kopyalanması veya kullanılması kesinlikle yasaktır.
              </p>
              <h6>Genel Sorumluluklar</h6>
              <p>
                Site içerisinde daha önceden haber vermeksizin değişiklik yapma hakkı işkıbrıs.com tarafından saklı tutulmaktadır. Sitede yer alan bireysel kullanıcı ve firma
                bilgilerinden işkıbrıs.com sorumlu tutulamaz. Sitede Cv&lsquo;sini oluşturan adayın ilettiği her türlü bilginin tek sorumlusu adaydır. Aday bu bilgileri kendi
                oluşturduğunu ve her türlü bilginin doğru olduğunu kabul etmektedir. işkıbrıs.com veritabanında bulundurduğu Cv&lsquo;lerin sorumluluğunu alamaz. Sitenin üyelerine
                iş ve/veya aday bulmak gibi bir sorumluluğu yoktur. Firmalar ve adaylar arasında oluşan her türlü ilişkiden firma ve adaylar kendileri sorumludur. işkıbrıs.com
                sitenin çalışması amacıyla kullandığı yazılımlarla ilgili sorumluluk almamaktadır. Sitede yer alan herhangi bir yazılım sebebi ile kullandığınız yazılım ve donanım
                unsurlarına herhangi bir zarar gelmesinden dolayıişkıbrıs.com&lsquo;a bu konu ile ilgili bir sorumluluk yüklenemez. işkıbrıs.com, sitenin yazılımının her türlü
                hatadan arınmış olduğunu ve sitede herhangi bir virüs yer alıp almadığı ile ilgili bir sorumluluk yüklenmemektedir. işkıbrıs.com bu sitede yer alan her türlü bilgi,
                haber, makale ve diğer materyal ile ilgili herhangi bir sorumluluk kabul etmez. işkıbrıs.com gizlilik prensiplerine sadık kalarak bazı pazarlama faaliyetlerinde üye
                bilgilerini reklam, tanıtım ve pazarlama amacıyla kullanabilir. işkıbrıs.com reklam, tanıtım ve pazarlama amaçlı e-posta ve sms gönderimi yapabilir. Bu sitede
                paylaştığınız bilgilerin işkıbrıs.com tarafından ÜYE FİRMALAR HARİCİNDE üçüncü kişilerle paylaşılmasını; Site kapsamında işverenler ile adaylar arasında
                yapılabilecek online görüşmelerde tarafların güvenliği için ses ve görüntü kaydı alınacaktır. işkıbrıs.com’un ilgili kayıtlar ile ilgili cezai veya hukuki hiçbir
                sorumluluğu bulunmamaktadır. işkıbrıs.com&lsquo;a gösterdiğiniz ilgi ve güven nedeni ile teşekkür ederiz.
              </p>
            </main>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default TermsAndConditions
